// node_modules
import { 
    FC
} from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExpandAlt } from "@fortawesome/free-solid-svg-icons";
// Components
import { MarkdownItComponent } from "Components/Shared";
// styles
import styles from "./image.module.scss";

type TImageProps = {
    id?: number,
    caption?: string,
    link: string,
    technologyId?: number,
    isExpandable?: boolean
}

export const Image: FC<TImageProps> = ({id, caption, link, technologyId, isExpandable}: TImageProps) => {
    return (
        <div className={styles.imageContainer}>
            {isExpandable  && id && technologyId ? 
                <a href={`#image-${id}-${technologyId}`}>
                    <div className={styles.imageExpand} title={"Expend figure"}>
                        <FontAwesomeIcon icon={faExpandAlt} />
                    </div>
                </a>
            :
                null
            }
            <div className={styles.aspectRatioBox}>
                <div className={styles.aspectRatioBoxContent}>
                    <img className={styles.image} src={link} alt="Technology" />
                </div>
            </div>
            {caption && <MarkdownItComponent source={caption} noSource={" "} env={technologyId ? {"technologyId": technologyId} : undefined} />}
        </div>
    );
};
